export default __webpack_public_path__ + "static/media/oxygen-result.7b443098.svg";